import { BUS_ASSET_VIDEOS } from '@lib/shared';

/**
 * Every catalog slot except the internal "Garanzia" one, which never reaches Fleequid. The label map
 * below is exhaustive, so a new published slot breaks this file until it is named.
 */
type PublishedVideoName = {
    [K in keyof typeof BUS_ASSET_VIDEOS]: (typeof BUS_ASSET_VIDEOS)[K]['isInternal'] extends true ? never : K;
}[keyof typeof BUS_ASSET_VIDEOS];

const VIDEO_LABEL_KEYS: Record<PublishedVideoName, TranslationKey> = {
    video_engine_working: 'sdp.videoLabel.engine',
    video_wheelchair_ramp_working: 'sdp.videoLabel.wheelchairRamp',
    video_internal_driver_to_end: 'sdp.videoLabel.interior',
    video_internal_second: 'sdp.videoLabel.interiorSecond',
    video_internal_second_floor_reverse_seats_full: 'sdp.videoLabel.upperDeck',
    video_internal_second_floor_second: 'sdp.videoLabel.upperDeckSecond',
};

const isPublishedVideoName = (name: string): name is PublishedVideoName => Object.hasOwn(VIDEO_LABEL_KEYS, name);

/**
 * A video src ends with its catalog slot name (`…/videos/video_engine_working`). Assets predating the
 * catalog are named `{position}_VIDEOS_{BUCKET}`; only the engine bucket says what such a video shows, so any
 * other video stays unlabelled.
 */
export const saleVideoLabelKey = (videoSource: string): TranslationKey | undefined => {
    const name = videoSource.split('/').pop() ?? '';

    if (isPublishedVideoName(name)) {
        return VIDEO_LABEL_KEYS[name];
    }

    return /engine/i.test(name) ? 'sdp.videoLabel.engine' : undefined;
};
